module.exports = __webpack_public_path__ + "static/media/wizard_open_ic.9d4a8b94.svg";